var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
var CustomerReqDocComponent = /** @class */ (function () {
    function CustomerReqDocComponent(apiService, util, fb, activatedRoute) {
        this.apiService = apiService;
        this.util = util;
        this.fb = fb;
        this.activatedRoute = activatedRoute;
        this.contactId = "";
        this.contact = {};
        this.disablebtnSave = false;
        this.isCheckedAll = false;
        this.contactDrosD03List = [];
        this.mobileOTPDrosD02 = "";
        this.UIDD02 = "";
        this.disableResentOtp = false;
        this.totolWaitResend = 59;
        this.otp = "";
        this.otpRef = "";
        this.requestOtpLbl = "ส่ง";
        this.otpTimer = "";
        this.ElapseTime = 0;
        this.TotalTime = 0;
        this.OTPCountDown = "";
        this.displayStyle = "none";
        this.otpmobile = "";
        this.verifyOtp = "";
        this.mobilenomasking = "";
        this.mobilemasking = "";
        this.submitted = false;
    }
    CustomerReqDocComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    CustomerReqDocComponent.prototype.init = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            function matchCustom(params, data) {
                // If there are no search terms, return all of the data
                if ($.trim(params.term) === '') {
                    return data;
                }
                // Do not display the item if there is no 'text' property
                if (typeof data.text === 'undefined') {
                    return null;
                }
                if (params.term.length > 1) {
                    // `params.term` should be the term that is used for searching
                    // `data.text` is the text that is displayed for the data object
                    if (data.text.indexOf(params.term) > -1) {
                        // You can return modified objects from here
                        // This includes matching the `children` how you want in nested data sets
                        return data;
                    }
                }
                // Return `null` if the term should not be displayed
                return null;
            }
            var thisTs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        thisTs = this;
                        this.contactId = this.activatedRoute.snapshot.paramMap.get('id');
                        this.util.ShowWaiting(true);
                        return [4 /*yield*/, this.initData()];
                    case 1:
                        _a.sent();
                        $('.select2').select2({
                            // matcher: function (term: any, text: any, option: any) {
                            //   return option.hasClass('car');
                            // }
                            matcher: matchCustom
                        });
                        $(".select2").on("change", function (e) {
                            thisTs.addressChange(e.target.value);
                        });
                        this.util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerReqDocComponent.prototype.onCheckAllChange = function () {
        $(".row-checker").prop("checked", this.isCheckedAll);
    };
    CustomerReqDocComponent.prototype.getSelectedContact = function () {
        var thisTs = this;
        this.selectList = [];
        $('.row-checker:checkbox:checked').each(function () {
            var value = {
                RequestedNo: $(this).val()
            };
            thisTs.selectList.push(value);
        });
    };
    CustomerReqDocComponent.prototype.initData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.apiService.getMasterAddress()];
                    case 1:
                        _a.combinedAddressList = _c.sent();
                        _b = this;
                        return [4 /*yield*/, this.getContact()];
                    case 2:
                        _b.contact = _c.sent();
                        if (!(this.contact.dpa_companytypeid != null && this.contact.dpa_companytypeid.trim().length > 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.getDrosContact(this.contact.dpa_registrationid)];
                    case 3:
                        _c.sent();
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.getDrosContact(this.contact.dpa_idcard)];
                    case 5:
                        _c.sent();
                        _c.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    CustomerReqDocComponent.prototype.getContact = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        para = "contactid=" + this.contactId;
                        return [4 /*yield*/, this.apiService.get("crmservice", "contact", para)];
                    case 1:
                        tmp = _a.sent();
                        return [2 /*return*/, tmp[0]];
                }
            });
        });
    };
    CustomerReqDocComponent.prototype.getDrosContact = function (phoneNo) {
        return __awaiter(this, void 0, void 0, function () {
            var para, contactDros, hasRow, _i, _a, itm, reqdetail;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        para = "CRM02=true&CRM03=true";
                        if (phoneNo != null && phoneNo.trim().length != 0) {
                            para += "&dpa_id=" + phoneNo;
                        }
                        if (!(para == "CRM02=true&CRM03=true")) return [3 /*break*/, 1];
                        return [2 /*return*/];
                    case 1: return [4 /*yield*/, this.apiService.get("crmservice", "contactDros", para)];
                    case 2:
                        contactDros = _b.sent();
                        if (contactDros == null || contactDros.length == 0) {
                            this.util.WarningDialog("ไม่พบข้อมูลใน DROS");
                        }
                        else {
                            hasRow = false;
                            if (contactDros != null && contactDros.CRM03 != null) {
                                if (!this.util.IsNullOrUndefined(contactDros.CRM03)) {
                                    if (this.contactDrosD03List.length == 0) {
                                        for (_i = 0, _a = contactDros.CRM03; _i < _a.length; _i++) {
                                            itm = _a[_i];
                                            if (!this.util.IsNullOrUndefined(itm.FilePath)) {
                                                if (itm.FilePath.split('_')[1] != "05.pdf" && itm.FilePath.split('_')[1] != "07.pdf") {
                                                    if (itm.IsPrint != 1) {
                                                        hasRow = true;
                                                    }
                                                    reqdetail = {
                                                        RequestedNo: itm.RequestedNo,
                                                        RequestType: itm.RequestType,
                                                        StatusDefinition: itm.StatusDefinition,
                                                        isPrintMessage: itm.IsPrint == 1 ? "มีการขอเอกสารแล้ว" : ("สามารถขอเอกสารได้"),
                                                        UID: itm.UID,
                                                        isPrint: itm.IsPrint,
                                                    };
                                                    this.contactDrosD03List.push(reqdetail);
                                                }
                                            }
                                        }
                                    }
                                }
                                if (!hasRow) {
                                    this.disablebtnSave = true;
                                    //$("#savedata").addClass("sr-only");
                                }
                                //this.contactDrosD03List = contactDros.CRM03.filter((mb: any) => {
                                //return mb.FilePath != null &&  mb.FilePath != ""})
                                //this.contactDrosD03List = contactDros.CRM03;
                            }
                            if (!this.util.IsNullOrUndefined(this.contactDrosD03List) && this.contactDrosD03List.length == 0) {
                                $("#divNoData").removeClass("colhidden");
                                // $("#savedata").addClass("sr-only");
                                this.disablebtnSave = true;
                            }
                            if (contactDros != null && contactDros.CRM02 != null) {
                                this.mobileOTPDrosD02 = this.contact.telephone1;
                                this.UIDD02 = contactDros.CRM02[0].UID;
                                this.maskingMobile(this.mobileOTPDrosD02, 6);
                            }
                        }
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerReqDocComponent.prototype.requestOtp = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var reqOtp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.otpmobile = this.mobilenomasking;
                        if (this.mobilemasking.indexOf("x") == -1) {
                            //console.log("1")
                            this.otpmobile = this.mobilemasking;
                            //console.log(this.otpmobile)
                        }
                        else {
                            //console.log("2")
                            this.otpmobile = this.mobilenomasking;
                            //console.log(this.otpmobile)
                        }
                        if (this.otpmobile.length < 10) {
                            this.util.ErrorDialog("กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง");
                            return [2 /*return*/];
                        }
                        reqOtp = {
                            MobileNo: this.otpmobile,
                        };
                        return [4 /*yield*/, this.apiService.postCustom("crm", "RequestOTP", reqOtp).then(function (reqOtpRes) { return __awaiter(_this, void 0, void 0, function () {
                                var smsContent, sendSms, sendSmsRes;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!this.util.isSuccessResponse(reqOtpRes)) return [3 /*break*/, 2];
                                            this.otpRef = reqOtpRes.RefCode;
                                            smsContent = "รหัสตรวจสอบการยืนยันตัวตนของคุณคือ : ";
                                            smsContent += reqOtpRes.otpNo + " ";
                                            smsContent += "(RefCode : " + reqOtpRes.RefCode;
                                            smsContent += ") (รหัสมีอายุ " + reqOtpRes.expInMinute + " นาที) อย่าเปิดเผยรหัสกับผู้อื่น";
                                            sendSms = {
                                                dpa_description: smsContent,
                                                dpa_phoneno: this.otpmobile
                                            };
                                            return [4 /*yield*/, this.apiService.post("crmservice", "sendSms", sendSms)];
                                        case 1:
                                            sendSmsRes = _a.sent();
                                            if (this.util.isSuccessResponse(sendSmsRes)) {
                                                this.otpRef = reqOtpRes.RefCode;
                                                this.otpTimer = 59;
                                                this.lastReqTime = new Date();
                                                this.requestOtpLbl = "ส่งอีกครั้ง";
                                                this.disableResentOtp = true;
                                                if (reqOtpRes.expInMinute == undefined || reqOtpRes.expInMinute == null) {
                                                    this.TotalTime = 300;
                                                }
                                                else {
                                                    this.TotalTime = reqOtpRes.expInMinute * 60;
                                                }
                                                this.ElapseTime = 0;
                                                if (this.SubScr != undefined) {
                                                    this.SubScr.unsubscribe();
                                                }
                                                //this.SubScr = timer(0, 1000).subscribe(() => this.CountDownOTP());
                                            }
                                            else {
                                                this.util.ErrorDialog("เกิดข้อผิดพลาดในการ ขอ Otp กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่");
                                            }
                                            return [3 /*break*/, 3];
                                        case 2:
                                            this.util.ErrorDialog("เกิดข้อผิดพลาดในการ ขอ Otp กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่");
                                            _a.label = 3;
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerReqDocComponent.prototype.verify = function () {
        return __awaiter(this, void 0, void 0, function () {
            var reqCheckOtp, reqCheckOtpRes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.verifyOtp.trim().length > 0)) return [3 /*break*/, 2];
                        this.util.ShowWaiting(true);
                        reqCheckOtp = {
                            OTP: this.verifyOtp.trim(),
                            RefCode: this.otpRef,
                            MobileNo: this.otpmobile
                        };
                        return [4 /*yield*/, this.apiService.postCustom("crm", "VerifyOTP", reqCheckOtp)];
                    case 1:
                        reqCheckOtpRes = _a.sent();
                        if (this.util.isSuccessResponse(reqCheckOtpRes)) {
                            if (reqCheckOtpRes.IsValid) {
                                //update ข้อมูลผ่าน api updateCRM08DROS 
                                this.updateCRM08DROS(this.contact);
                                this.util.ShowWaiting(false);
                                //this.util.SuccessDialog("ขอเอกสารสำเร็จ");
                            }
                            else {
                                this.util.ShowWaiting(false);
                                this.util.WarningDialog("รหัส OTP ที่ท่านกรอกไม่ถูกต้อง");
                            }
                        }
                        else {
                            this.util.ShowWaiting(false);
                            this.util.WarningDialog("พบข้อผิดพลาดในการยืนยันรหัส OTP กรูณาลองใหม่อีกครั้งหรือติดต่อเจ้าหน้าที่");
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        this.util.WarningDialog("กรุณากรอกรหัส OTP");
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerReqDocComponent.prototype.openstatus = function (drosReqNo) {
        return __awaiter(this, void 0, void 0, function () {
            var para, tmp, objDetail, docStatus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        para = "UID=" + this.UIDD02;
                        return [4 /*yield*/, this.apiService.get("crmservice", "getCRM08DROS", para)];
                    case 1:
                        tmp = _a.sent();
                        objDetail = tmp.find(function (e) { return e.DROSRequestNo === drosReqNo; });
                        docStatus = "";
                        if (!this.util.IsNullOrUndefined(objDetail.ErrorMessage)) {
                            this.util.WarningDialog(objDetail.ErrorMessage);
                        }
                        else {
                            if (objDetail.SentStatus === "1") {
                                docStatus = "ดำเนินการจัดส่งเอกสารแล้ว";
                            }
                            else if (objDetail.PrintStatus === "1") {
                                docStatus = "อยู่ระหว่างการจัดทำเอกสาร";
                            }
                            else if (objDetail.IsRead === "1") {
                                docStatus = "ได้รับคำขอ";
                            }
                            else {
                                docStatus = "สร้างรายการ";
                            }
                            this.util.WarningDialog("สถานะการขอเอกสารล่าสุด " + docStatus + " เมื่อวันที่ : " + this.util.transformDate(objDetail.ModifiedOn, "short"));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerReqDocComponent.prototype.updateCRM08DROS = function (inputcontact) {
        return __awaiter(this, void 0, void 0, function () {
            var that, req, RequestedNoList, Res, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        that = this;
                        req = [];
                        RequestedNoList = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        $('.row-checker:checkbox:checked').each(function () {
                            var value = {
                                DROSRequestNo: $(this).val(),
                                UID: that.UIDD02,
                                Status: "P",
                                Address: inputcontact.dpa_contact_homeno,
                                MooNo: inputcontact.dpa_contact_moo,
                                StreetName: inputcontact.dpa_contact_street,
                                LocationCode: inputcontact.dpa_contact_subdistict,
                                Zipcode: inputcontact.dpa_contact_postcodename,
                                PhoneNo: that.otpmobile,
                            };
                            RequestedNoList.push(value);
                        });
                        return [4 /*yield*/, this.apiService.post("crmservice", "updateCRM08DROS", RequestedNoList)];
                    case 2:
                        Res = _a.sent();
                        if (Res != null && Res["Status"] != null && parseInt(Res["Status"]) == 200) {
                            this.displayStyle = "none";
                            this.otpRef = "";
                            this.verifyOtp = "";
                            this.disableResentOtp = false;
                            that.util.SuccessDialog("ขอเอกสารสำเร็จ");
                        }
                        else if (Res != null && Res["Status"] != null && parseInt(Res["Status"]) == 201) {
                            this.displayStyle = "none";
                            this.otpRef = "";
                            this.verifyOtp = "";
                            this.disableResentOtp = false;
                            this.util.WarningDialog("บันทึกข้อมูลไม่สำเร็จ มีคำขอซ้ำในระบบ");
                        }
                        else {
                            this.displayStyle = "none";
                            this.otpRef = "";
                            this.verifyOtp = "";
                            this.disableResentOtp = false;
                            that.util.ErrorDialog("ขอเอกสารไม่สำเร็จ");
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CustomerReqDocComponent.prototype.maskingMobile = function (tel, digittomask) {
        if (tel) {
            var telonmask = tel.substring(digittomask, tel.length);
            var xmark = "";
            for (var i = 0; i < digittomask; i++) {
                xmark = xmark + "x";
            }
            this.mobilenomasking = tel;
            this.mobilemasking = xmark + telonmask;
        }
        else {
            this.mobilenomasking = tel;
            this.mobilemasking = tel;
        }
    };
    CustomerReqDocComponent.prototype.isFormValid = function () {
        if (this.contact.firstname == null) {
            this.contact.firstname = "";
        }
        if (this.contact.lastname == null) {
            this.contact.lastname = "";
        }
        if (this.contact.dpa_contact_homeno == null) {
            this.contact.dpa_contact_homeno = "";
        }
        if (this.contact.dpa_contact_subdistictname == null) {
            this.contact.dpa_contact_subdistictname = "";
        }
        if (this.contact.dpa_contact_distictname == null) {
            this.contact.dpa_contact_distictname = "";
        }
        if (this.contact.dpa_contact_provincname == null) {
            this.contact.dpa_contact_provincname = "";
        }
        if (this.contact.dpa_contact_postcodename == null) {
            this.contact.dpa_contact_postcodename = "";
        }
        return this.contact.firstname != "" &&
            this.contact.firstname.trim().length > 0 &&
            this.contact.dpa_contact_homeno != "" &&
            this.contact.dpa_contact_homeno.trim().length > 0 &&
            this.contact.dpa_contact_subdistictname != "" &&
            this.contact.dpa_contact_subdistictname.trim().length > 0 &&
            this.contact.dpa_contact_distictname != "" &&
            this.contact.dpa_contact_distictname.trim().length > 0 &&
            this.contact.dpa_contact_provincname != "" &&
            this.contact.dpa_contact_provincname.trim().length > 0 &&
            this.contact.dpa_contact_postcodename != "" &&
            this.contact.dpa_contact_postcodename.trim().length > 0;
    };
    CustomerReqDocComponent.prototype.addressChange = function (value) {
        var selected = this.combinedAddressList.filter(function (a) { return a.id == value; });
        if (selected != null && selected.length > 0) {
            var values = selected[0].id.split("|");
            var texts = selected[0].text.split(" | ");
            this.contact.dpa_contact_subdistict = values[0];
            this.contact.dpa_contact_distict = values[1];
            this.contact.dpa_contact_province = values[2];
            this.contact.dpa_contact_postcode = values[3];
            this.contact.dpa_contact_country = values[4];
            this.contact.dpa_contact_subdistictname = texts[0];
            this.contact.dpa_contact_distictname = texts[1];
            this.contact.dpa_contact_provincname = texts[2];
            this.contact.dpa_contact_postcodename = texts[3];
            this.contact.dpa_contact_countryname = texts[4];
        }
        else {
            this.contact.dpa_contact_subdistict = "";
            this.contact.dpa_contact_distict = "";
            this.contact.dpa_contact_province = "";
            this.contact.dpa_contact_postcode = "";
            this.contact.dpa_contact_country = "";
            this.contact.dpa_contact_subdistictname = "";
            this.contact.dpa_contact_distictname = "";
            this.contact.dpa_contact_provincname = "";
            this.contact.dpa_contact_postcodename = "";
            this.contact.dpa_contact_countryname = "";
        }
    };
    CustomerReqDocComponent.prototype.save = function () {
        this.submitted = true;
        if (this.isFormValid()) {
            this.getSelectedContact();
            if (this.selectList.length < 1) {
                this.util.WarningDialog("กรุณาเลือกอย่างน้อย 1 รายการ");
            }
            else {
                this.displayStyle = "block";
            }
        }
    };
    CustomerReqDocComponent.prototype.close = function () {
        this.displayStyle = "none";
        this.otpRef = "";
        this.verifyOtp = "";
        this.disableResentOtp = false;
    };
    return CustomerReqDocComponent;
}());
export { CustomerReqDocComponent };



// WEBPACK FOOTER //
// ./src/app/customer-req-doc/customer-req-doc.component.ts.pre-build-optimizer.js